import _ from 'lodash';
import api from '../api';

const BASE_URL = '/api/v2/rss-feeds';

const RssFeedsApi = {
	listRssFeeds: (params) =>
		api.get(BASE_URL, { params: _.omitBy(params, (v) => ['', null, undefined].includes(v)) }),
	getRssFeed: (rssFeedId) => api.get(`${BASE_URL}/${rssFeedId}`),
	createRssFeed: (payload) => api.post(BASE_URL, payload),
	updateRssFeed: (rssFeedId, payload) => api.put(`${BASE_URL}/${rssFeedId}`, payload),
	deleteRssFeed: (rssFeedId) => api.delete(`${BASE_URL}/${rssFeedId}`),
};

export default RssFeedsApi;
